import { render, staticRenderFns } from "./iconBurger.vue?vue&type=template&id=3f42a13f&"
import script from "./iconBurger.vue?vue&type=script&lang=js&"
export * from "./iconBurger.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports